<template>
  <div :class="`custom-row ${customClass || ''}`" >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TableRow',
  props: ['customClass']
}
</script>
